import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from "@angular/core";

@Component({
	selector: 'skl-info-announcement-toast-component',
	template: `
		<span [innerHTML]="template()"></span>
	`,
	styles: [`
		:host {
			font-size: .9rem;
			text-wrap: pretty;
			color: var(--text-minor-color);
		}
	`],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoAnnouncementToastComponent {
	public readonly template = input<any>();
}
